const routerWebViewCourseSquare = {
  path: "/mobile/webViewCourseSquare",
  name: "webView",
  component: () => import("@/webViewCourseSquare/home.vue"),
  children: [
    // 嵌入到第三方的页面
    {
      path: "index",
      name: "mobile_viewWeb_CourseSquare_index",
      component: () => import("@/webViewCourseSquare/index"),
      meta: { name: "课程广场" }
    },
    {
      path: "types/:typeId",
      name: "mobile_viewWeb_CourseSquare_types",
      component: () => import("@/webViewCourseSquare/types"),
      meta: { name: "分类" }
    },
    {
      path: "videoInfo",
      name: "mobile_viewWeb_CourseSquare_videoInfo",
      component: () => import("@/webViewCourseSquare/videoInfo"),
      meta: { name: "视频详情" }
    },
  ]
}

export default routerWebViewCourseSquare;



// WEBPACK FOOTER //
// ./src/router/routerWebViewCourseSquare.js